<template>
  <footer class="main-footer">
    <div class="footer-content">
      <div class="footer-section">
        <h4>关于我们</h4>
        <ul>
          <li><a href="#">公司简介</a></li>
          <li><a href="#">企业文化</a></li>
          <li><a href="#">联系我们</a></li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>帮助中心</h4>
        <ul>
          <li><a href="#">购物指南</a></li>
          <li><a href="#">支付方式</a></li>
          <li><a href="#">售后服务</a></li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>商家服务</h4>
        <ul>
          <li><a href="#">商家入驻</a></li>
          <li><a href="#">商家中心</a></li>
          <li><a href="#">物流服务</a></li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>关注我们</h4>
        <div class="social-links">
          <a href="#" class="social-link">微信</a>
          <a href="#" class="social-link">微博</a>
          <a href="#" class="social-link">抖音</a>
        </div>
        <p>官方微信: mall_official</p>
        <p>客服热线: 400-123-4567</p>
        <p>客服邮箱: service@example.com</p>
      </div>
    </div>
    <div class="footer-bottom">
      <p>&copy; 2025天狗商城. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script setup>
// 这个组件很简单，不需要JS逻辑
</script>

<style scoped>
.main-footer {
  background: linear-gradient(135deg, #2c3e50, #4a6491);
  color: #ecf0f1;
  padding: 60px 20px 30px;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.footer-section {
  flex: 1;
  min-width: 200px;
}

.footer-section h4 {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 1.2em;
  position: relative;
  padding-bottom: 10px;
}

.footer-section h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #5e72e4, #9b59b6);
  border-radius: 3px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 12px;
}

.footer-section a, .footer-section p {
  color: #bdc3c7;
  text-decoration: none;
  font-size: 0.95em;
  transition: all 0.3s ease;
}

.footer-section a:hover {
  color: #ffffff;
  transform: translateX(5px);
}

.social-links {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.social-link {
  display: inline-block;
  padding: 8px 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #5e72e4;
  transform: translateY(-3px);
}

.footer-bottom {
  text-align: center;
  margin-top: 40px;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9em;
  color: #95a5a6;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .main-footer {
    padding: 40px 15px 20px;
  }
}
</style>